package com.neurobs.react.semanticui

import com.neurobs.react.ElementModifiers
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.ReactElement
import slinky.core.facade.Hooks.useEffect
import slinky.web.html._

import scala.scalajs.js

object UiAccordionFactory {

  private def TemplateAccordion(children: ReactElement*)(uiElementModifiers: UiElementModifiers) = {

    @react
    object AccordionElement {
      case class Props()
      val component = FunctionalComponent[Props] { _ =>

        useEffect(() => {
          js.Dynamic.global.initializeAccordion()
        }, Vector())

        div(
          className := uiElementModifiers.formattedClassName("accordion"),
          style := uiElementModifiers.createStyle
        )(
          children
        )

      }
    }

    AccordionElement()
  }

  def Accordion(children: ReactElement*)(implicit uiElementModifiers: UiElementModifiers) = {
    TemplateAccordion(children)(uiElementModifiers)
  }

  private def TemplateTitle(active: Boolean, children: ReactElement*)(elementModifiers: ElementModifiers) = {
    div(
      className := s"${if (active) "active " else ""}title " + elementModifiers.classString,
      style := elementModifiers.createStyle
    )(
      children
    )
  }

  def Title(children: ReactElement*)(implicit elementModifiers: ElementModifiers) = TemplateTitle(false, children)(elementModifiers)
  def ActiveTitle(children: ReactElement*)(implicit elementModifiers: ElementModifiers) = TemplateTitle(true, children)(elementModifiers)

  def DropdownTitle(title: String)(implicit elementModifiers: ElementModifiers) = {
    Title(
      UiIconFactory.Icon("dropdown"),
      title
    )
  }

  private def TemplateContent(active: Boolean, children: ReactElement*)(elementModifiers: ElementModifiers) = {
    div(
      className := s"${if (active) "active " else ""}content " + elementModifiers.classString,
      style := elementModifiers.createStyle
    )(
      children
    )
  }

  def Content(children: ReactElement*)(implicit elementModifiers: ElementModifiers) = TemplateContent(false, children)(elementModifiers)
  def ActiveContent(children: ReactElement*)(implicit elementModifiers: ElementModifiers) = TemplateContent(true, children)(elementModifiers)
}
